import React, { useEffect, useState } from "react";
import Popularbusreport from "./Popularbusreport";
import Genderdistributionreport from "./Genderdistributionreport";
import Busoccupancyreport from "./Busoccupancyreport";
import { connect } from "react-redux";
import Driverreport from "./Driverreport";
import Boardinglogreport from "./Boardinglogreport";
import Exceptionreport from "./Exceptionreport";
import Travelhistory from "./Travelhistory";
import Auditlog from "./Auditlog";
import Stopreport from "./Stopreport";
import BusReplacementLog from "../Bus/BusReplacementLogs";
import BusTravelLog from "./BusTravelLog";
import ReplaceLog from "./ReplaceLog";

const ReportPage = ({ reportType }) => {
  const viewreport = () => {
    console.log("reportType?.value", reportType?.value);
    switch (reportType?.value.toLowerCase()) {
      case "popularbusreport":
        return <Popularbusreport />;
      case "busoccupancyreport":
        return <Busoccupancyreport />;
      case "genderdistributionreport":
        return <Genderdistributionreport />;
      case "driverreport":
        return <Driverreport/>;
      case "boarding history":
        return <Boardinglogreport/>;
      case "exception report":
        return <Exceptionreport/>;  
      case "travel history":
        return <Travelhistory/>; 
      case "auditlog":
        return <Auditlog/>;  
      case "stop report":
        return <Stopreport/>; 
      case "travel log":
        return <BusTravelLog/>; 
      case "replace log":
        return <ReplaceLog/>;   
      default:
        return <div className="text-center">Select reports</div>;
    }
  };
  return viewreport();
};

const mapStateToProps = (state) => ({
  reportType: state.auth.reportType,
});

export default connect(mapStateToProps)(ReportPage);
